import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {Persona} from '../models';
import {ApiService} from '../../shared';

@Injectable({
  providedIn: 'root'
})
export class PersonaService extends ApiService<Persona> {
  protected dataKey = 'personas';
  protected objectKey = 'Personas';
  protected sendObjectKey = 'personas';
  protected sendObjectIdsKey = 'id';

  constructor(protected httpClient: HttpClient) {
    super(Persona, httpClient, 'apiSeguroUrl');
  }
}
